import * as React from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { FieldConstraintModelInput, FieldKeyModel } from '@utmost.co/enterprise-models';
import { SmartformElementData, ElementWithMeta, SmartFormElements, ElementQueryResult } from '../types';
import { InputModel } from '../forms/utils';
import { ElementErrorBoundary } from './ElementErrorBoundary';

export function getComponent<Type extends string, Model = InputModel>(
  element: ElementWithMeta<Model>,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>,
  isValidating: boolean,
  submitted: boolean,
  formElements: SmartFormElements<Type, Model>,
  getElementByFieldKey: (fieldKey: FieldKeyModel, customFieldId?: string) => ElementQueryResult<Model> | null,
  getConstraintsByFieldKey: (
    fieldKey: FieldKeyModel,
    customFieldId?: string
  ) => FieldConstraintModelInput[] | undefined,
  hideEmptyHints?: boolean,
  patchError?: { code: string; message: string }
) {
  const props: SmartformElementData<Model> = {
    element,
    touched,
    errors,
    submitted,
    isValidating,
    hideEmptyHints,
    patchError,
    getElementByFieldKey,
    getConstraintsByFieldKey
  };
  if (formElements.has(element.type as Type)) {
    const Element = formElements.get(element.type as Type)!.component;
    return (
      <ElementErrorBoundary>
        <Element {...props} />
      </ElementErrorBoundary>
    );
  }
  return null;
}
